import history from "../history";
import { removeItem } from "./localStorageService";
import { removeSessionItem } from "./sessionStorageService";
import { LOGIN } from "./Routes";
import { store } from "../Store/store";
import {
  setUserSessionTimeOut,
  isSuccessfullyLoggedIn,
} from "../Store/Login/loginActions";
import { destroyToken } from "../utils/apiService/accountApiService";

export default async function logUserOut() {
  await destroyToken();
  store.dispatch(setUserSessionTimeOut(true));
  removeItem("AUTH");
  removeItem("language");
  removeSessionItem("languageSessionOnly");
  store.dispatch(isSuccessfullyLoggedIn(false));
  history.push(LOGIN);
}
